import { render, staticRenderFns } from "./CompetencyTestSessionItem.vue?vue&type=template&id=55947a59"
import script from "./CompetencyTestSessionItem.vue?vue&type=script&lang=js"
export * from "./CompetencyTestSessionItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports